import * as React from "react";
import {StatuteBlockWrapper,StatuteSectionHeader,StatuteBlock} from "./statute-elements";

interface CookieStatuteBlockProps {}

const CookieStatuteBlock = (props: CookieStatuteBlockProps) => {
  return (
    <div className="materialize-theme-styles">
      <StatuteBlockWrapper>

        <StatuteBlock>
          <p>
            Niniejsza Polityka Prywatności określa zasady przechowywania i dostępu do informacji na urządzeniach Użytkownika za pomocą plików Cookies,
            służących realizacji usług świadczonych drogą elektroniczną żądanych przez Użytkownika, przez Fakturomania Sp. z o.o.  z siedzibą w Grodzisku Mazowieckim.
          </p>
        </StatuteBlock>

        <StatuteSectionHeader ordinal={1} sectionName="Definicje "/>
        <StatuteBlock>
          <ol>
            <li>
              <strong>Administrator</strong> - oznacza Fakturomanię Spółkę z ograniczoną odpowiedzialnością z siedzibą w Grodzisku Mazowieckim,
              ul. Gen. L. Okulickiego 19B lok. 11, wpisaną do rejestru przedsiębiorców Krajowego Rejestru Sądowego prowadzonego przez Sąd Rejonowy
              dla m. st. Warszawy w Warszawie, XIV Wydział Gospodarczy pod numerem KRS 0000495029, NIP: 5291802680, Regon: 147060749,
              który świadczy usługi drogą elektroniczną oraz przechowuje i uzyskuje dostęp do informacji w urządzeniach Użytkownika.
            </li>
            <li>
              <strong>Cookies</strong> - oznacza dane informatyczne, w szczególności niewielkie pliki tekstowe, zapisywane i przechowywane
              na urządzeniach, za pośrednictwem których Użytkownik korzysta ze stron internetowych Serwisu.
            </li>
            <li>
              <strong>Cookies Administratora</strong> - oznacza Cookies zamieszczane przez Administratora, związane ze świadczeniem usług
              drogą elektroniczną przez Administratora za pośrednictwem Serwisu.
            </li>
            <li>
              <strong>Cookies Zewnętrzne</strong> - oznacza Cookies zamieszczane przez partnerów Administratora za pośrednictwem strony internetowej Serwisu.
            </li>
            <li>
              <strong>Serwis</strong> - oznacza stronę internetową, pod którą Administrator prowadzi serwis internetowy, działającą w domenie <a href="https://fakturomania.pl">www.fakturomania.pl</a>.
            </li>
            <li>
              <strong>Urządzenie</strong> - oznacza elektroniczne urządzenie, za pośrednictwem którego Użytkownik uzyskuje dostęp do stron internetowych Serwisu.
            </li>
            <li>
              <strong>Użytkownik</strong> - oznacza podmiot, na rzecz którego zgodnie z Regulaminem i przepisami prawa mogą być świadczone usługi drogą
              elektroniczną lub z którym zawarta może być Umowa o świadczenie usług drogą elektroniczną.
            </li>
          </ol>
        </StatuteBlock>

        <StatuteSectionHeader ordinal={2} sectionName="Rodzaje wykorzystywanych Cookies "/>
        <StatuteBlock>
          <ol>
            <li>
              Stosowane przez Administratora Cookies są bezpieczne dla Urządzenia Użytkownika. W szczególności tą drogą nie jest możliwe
              przedostanie się do Urządzeń Użytkowników wirusów lub innego niechcianego oprogramowania lub oprogramowania złośliwego.
              Pliki te pozwalają zidentyfikować oprogramowanie wykorzystywane przez Użytkownika i dostosować Serwis indywidualnie każdemu Użytkownikowi.
              Cookies zazwyczaj zawierają nazwę domeny z której pochodzą, czas przechowywania ich na Urządzeniu oraz przypisaną wartość.
            </li>
            <li>
              Administrator wykorzystuje dwa typy plików cookies:
              <ol>
                <li>
                  Cookies sesyjne: są przechowywane na Urządzeniu Użytkownika i pozostają tam do momentu zakończenia sesji danej przeglądarki.
                  Zapisane informacje są wówczas trwale usuwane z pamięci Urządzenia. Mechanizm cookies sesyjnych nie pozwala na pobieranie jakichkolwiek danych osobowych,
                  ani żadnych informacji poufnych z Urządzenia Użytkownika.
                </li>
                <li>
                  Cookies trwałe: są przechowywane na Urządzeniu Użytkownika i pozostają tam do momentu ich skasowania. Zakończenie sesji danej przeglądarki lub wyłączenie
                  Urządzenia nie powoduje ich usunięcia z Urządzenia Użytkownika. Mechanizm cookies trwałych nie pozwala na pobieranie jakichkolwiek danych osobowych
                  ani żadnych informacji poufnych z Urządzenia Użytkownika.
                </li>
                <li>
                  Użytkownik ma możliwość ograniczenia lub wyłączenia dostępu plików cookies do swojego Urządzenia. W przypadku skorzystania z tej opcji
                  korzystanie ze Serwisu będzie możliwe, poza funkcjami, które wymagają plików cookies.
                </li>
              </ol>
            </li>
          </ol>
        </StatuteBlock>

        <StatuteSectionHeader ordinal={3} sectionName="Cele w jakich wykorzystywane są Cookies"/>
        <StatuteBlock>
          <ol>
            <li>
              Administrator wykorzystuje Cookies własne w celu poprawnej konfiguracji Serwisu, a w szczególności do:
              <ol>
                <li>
                  dostosowania zawartości stron internetowych Serwisu do preferencji Użytkownika oraz optymalizacji korzystania ze stron internetowych Serwisu,
                </li>
                <li>
                  rozpoznania urządzenia Użytkownika Serwisu oraz jego lokalizację i odpowiedniego wyświetlenia strony internetowej, dostosowanej do jego indywidualnych potrzeb,
                </li>
                <li>
                  zapamiętania ustawień wybranych przez Użytkownika i personalizacji interfejsu Użytkownika, np. w zakresie wybranego języka lub regionu, z którego pochodzi Użytkownik,
                </li>
                <li>
                  zapamiętania historii odwiedzonych stron w Serwisie w celu rekomendacji treści,
                </li>
                <li>
                  rozmiaru czcionki, wyglądu strony internetowej itp.
                </li>
              </ol>
            </li>
            <li>
              Administrator wykorzystuje Cookies własne w celu uwierzytelniania Użytkownika w Serwisie i zapewnienia sesji Użytkownika w Serwisie, a w szczególności do:
              <ol>
                <li>
                  utrzymania sesji Użytkownika Serwisu (po zalogowaniu), dzięki której Użytkownik nie musi na każdej podstronie Serwisu ponownie wpisywać loginu i hasła,
                </li>
                <li>
                  poprawnej konfiguracji wybranych funkcji Serwisu, umożliwiając w szczególności weryfikację autentyczności sesji przeglądarki,
                </li>
                <li>
                  optymalizacji i zwiększenia wydajności usług świadczonych przez Administratora.
                </li>
              </ol>
            </li>
            <li>
              Administrator wykorzystuje Cookies własne w celu realizacji procesów niezbędnych dla pełnej funkcjonalności stron internetowych, a w szczególności do:
              <ol>
                <li>
                  dostosowania zawartości stron internetowych Serwisu do preferencji Użytkownika oraz optymalizacji korzystania ze stron internetowych Serwisu.
                  W szczególności pliki te pozwalają rozpoznać podstawowe parametry Urządzenia Użytkownika i odpowiednio wyświetlić stronę internetową, dostosowaną do jego indywidualnych potrzeb,
                </li>
                <li>
                  poprawnej obsługi programu partnerskiego, umożliwiając w szczególności weryfikację źródeł przekierowań Użytkowników na strony internetowe Serwisu.
                </li>
              </ol>
            </li>
            <li>
              Administrator wykorzystuje Cookies własne w celu zapamiętania lokalizacji użytkownika, a w szczególności do poprawnej konfiguracji wybranych funkcji Serwisu,
              umożliwiając dostosowanie dostarczanych informacji do Użytkownika z uwzględnieniem jego lokalizacji.
            </li>
            <li>
              Administrator wykorzystuje Cookies własne w celu analiz i badań oraz audytu oglądalności, a w szczególności do tworzenia anonimowych
              statystyk, które pomagają zrozumieć, w jaki sposób Użytkownicy Serwisu korzystają ze stron internetowych Serwisu, co umożliwia ulepszanie ich struktury i zawartości.
            </li>
            <li>
              Administrator wykorzystuje Cookies własne w celu świadczenia usług reklamowych, a w szczególności do dostosowania prezentowanych za pośrednictwem Serwisu reklam usług i produktów firm trzecich.
            </li>
            <li>
              Administrator usługi wykorzystuje Cookies zewnętrzne w celu zalogowania do Serwisu za pomocą serwisu społecznościowego poprzez
              Facebook Connect (administrator cookies zewnętrznego: Facebook Inc z siedzibą w USA lub Facebook Ireland z siedzibą w Irlandii).
            </li>
            <li>
              Administrator usługi wykorzystuje Cookies zewnętrzne w celu zalogowania do Serwisu za pomocą serwisu społecznościowego Google (administrator cookies zewnętrznego: Google Inc z siedzibą w USA).
            </li>
            <li>
              Administrator usługi wykorzystuje Cookies zewnętrzne w celu popularyzacji Serwisu za pomocą serwisów społecznościowych plus.google.com (administrator cookies zewnętrznego: Google Inc z siedzibą w USA).
            </li>
            <li>
              Administrator usługi wykorzystuje Cookies zewnętrzne w celu popularyzacji Serwisu za pomocą serwisów społecznościowych Facebook.com
              (administrator cookies zewnętrznego: Facebook Inc z siedzibą w USA lub Facebook Ireland z siedzibą w Irlandii).
            </li>
          </ol>
        </StatuteBlock>

        <StatuteSectionHeader ordinal={4} sectionName="Możliwości określenia warunków przechowywania lub uzyskiwania dostępu przez Cookies"/>
        <StatuteBlock>
          <ol>
            <li>
              Użytkownik może samodzielnie i w każdym momencie zmienić ustawienia dotyczące plików Cookies, określając warunki ich przechowywania i uzyskiwania dostępu przez pliki
              Cookies do Urządzenia Użytkownika. Zmiany ustawień, o których mowa w zdaniu poprzednim, Użytkownik może dokonać za pomocą ustawień przeglądarki internetowej
              lub za pomocą konfiguracji usługi. Ustawienia te mogą zostać zmienione w szczególności w taki sposób, aby blokować automatyczną obsługę plików cookies w ustawieniach
              przeglądarki internetowej bądź informować o ich każdorazowym zamieszczeniu na urządzeniu Użytkownika. Szczegółowe informacje o możliwości i
              sposobach obsługi plików cookies dostępne są w ustawieniach oprogramowania (przeglądarki internetowej).
            </li>
            <li>
              Użytkownik może w każdej chwili usunąć pliki Cookies korzystając z dostępnych funkcji w przeglądarce internetowej, której używa.
            </li>
            <li>
              Ograniczenie stosowania plików Cookies, może wpłynąć na niektóre funkcjonalności dostępne na stronie internetowej Serwisu.
            </li>
          </ol>
        </StatuteBlock>

      </StatuteBlockWrapper>
    </div>
  )
};

export default CookieStatuteBlock


// WEBPACK FOOTER //
// ./src/layouts/statute-block/cookies-statute-block.tsx